import axiosInstance from '@/lib/axios/axiosInstance'
import { apiPath } from '@/constants/api-paths'
import type { ResponseContentEntity } from '@/models/response-types'
import type {
  MePermissions,
  Permission,
  PermissionDto,
  Role,
  RolePermissions,
  RolePermissionUpdateRequest,
  RolePermissionUpdateResult,
} from './permission.types'

export const permissionApi = {
  /*** GET /api/master/role — every role, in catalogue order */
  getRoles: async () => {
    const response = (await axiosInstance.get(apiPath.ROLE)) as unknown as ResponseContentEntity<
      Role[]
    >
    return response.data
  },

  /*** GET /api/master/permission — the catalogue */
  getCatalogue: async (): Promise<Permission[]> => {
    const response = (await axiosInstance.get(
      apiPath.PERMISSION,
    )) as unknown as ResponseContentEntity<PermissionDto[]>
    return response.data.map(({ code, ...rest }) => ({ ...rest, key: code }))
  },

  /*** GET /api/master/role-permission — the whole matrix in one call */
  getMatrix: async () => {
    const response = (await axiosInstance.get(
      apiPath.ROLE_PERMISSION,
    )) as unknown as ResponseContentEntity<RolePermissions[]>
    return response.data
  },

  /*** PUT /api/master/role-permission — apply a diff, one transaction */
  updateMatrix: async (payload: RolePermissionUpdateRequest) => {
    const response = (await axiosInstance.put(
      apiPath.ROLE_PERMISSION,
      payload,
    )) as unknown as ResponseContentEntity<RolePermissionUpdateResult>
    return response
  },

  /*** GET /api/master/me/permissions — the caller's roles and permission codes */
  getMine: async () => {
    const response = (await axiosInstance.get(
      apiPath.ME_PERMISSIONS,
    )) as unknown as ResponseContentEntity<MePermissions>
    return response.data
  },
}
